import React from 'react';
import { Modal, Button, Overlay, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import NextButton from '../../components/NextButton';
import BackButton from '../../components/BackButton';
import './InventoryList.css';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import SubmitDetails from '../SubmitDetails/SubmitDetails';
import AddItem from '../../components/AddItem/AddItem';
import Popup from '../../components/ToolTip';

class InventoryList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            detailsView: false,
            activeId: null,
            showAddItemModal: false,
            showOverlay: false
        }
    }
    handleCloseModal = () => {
        this.setState({showAddItemModal: false});
    }

    componentDidMount() {
        this.toggleUploadPopover();
    }

    toggleUploadPopover = () => {
        setTimeout(() => { 
            this.setState({showOverlay: true});    
        }, 1000);
        // setTimeout(() => { 
        //     this.setState({showOverlay: false});    
        // }, 4000);
    }

    viewDetails = (id) => {
        if (this.state.detailsView == true) {
            if (id == this.props.currentItem.lineItemId) {
                this.setState({detailsView: false, activeId: null});
            } else {
                this.props.editItem(id);
                this.setState({activeId: id});
            } 
        }
         else {
             this.setState({detailsView: true, activeId: id});
             this.props.editItem(id);
         } 
    }

    hideDetails = () => {
        this.setState({detailsView: false, activeId: null});
    }

    itemsList = (items) => {
        const length = items && items.length ? items.length : 0;
        
       return ( 
       <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={125}
            visibleSlides={length > 5 ? 5 : length+1}
            totalSlides={length+1}>
                <Slider>
         {items.map((item, i) => {
             console.log(items.length, i);
            const lastItem = i === items.length-1;
            const {activeId} = this.state;
            const activeClass = activeId !== null && item.lineItemId == activeId ? '--active-item' : '';
                return (
                    <Slide index={i} key={`item-${i}`} className={`inventory-list_item ${activeClass}`}>
                        <div>
                            <div className={`category-icon --${item.category}`}></div>
                        </div>
                        <div>
                            <p className="item-info-line-1">{item.name ? item.name : ""}</p>
                        </div>
                        <OverlayTrigger 
                        show={this.state.showOverlay && lastItem} 
                        placement="bottom"
                        overlay={
                        <Popover id={`popover-positioned-${i}`}>
                            <Popover.Content>
                            <span><strong>Have photos?</strong> Add them here</span>
                            </Popover.Content>
                      </Popover>} >
                        <div>
                       
                        <OverlayTrigger
                            key={`tooltip-${i}`}
                            placement="top"
                            overlay={
                                <Tooltip id={`tooltip-${i}`}>
                                    Add details & photos
                                </Tooltip>
                            }
                        >
                            <a href="#" className="edit-item" onClick={()=>this.viewDetails(item.lineItemId)} value={item.lineItemId}><span className="--edit"></span><span className="--upload"></span></a>
                        </OverlayTrigger>
                        
                        </div>
                        </OverlayTrigger>

                        <OverlayTrigger
                            key={`tooltip-${i}`}
                            placement="right"
                            overlay={
                                <Tooltip id={`tooltip-${i}`}>
                                    Delete
                                </Tooltip>
                            }
                        >
                        <a href="#" className="delete-item" onClick={()=>this.props.deleteItem(item.lineItemId)} value={item.lineItemId}></a>
                        </OverlayTrigger>
                    </Slide>
                );
            })

        }
            <Slide index={length + 1} className="inventory-list_item --add-item">
                <div className="add-icon"></div>
                <a href="#" onClick={this.handleAddItem} className="add-item-btn">Add More Items</a>
            </Slide>
            </Slider>
            <ButtonBack className="carousel-back-btn"></ButtonBack>
            <ButtonNext className="carousel-next-btn"></ButtonNext>
        </CarouselProvider>
       )
    }

    handleAddItem = () => {
        this.props.editItem(null);
        this.setState({
            detailsView: false,
            activeId: null,
            showAddItemModal: true
        });
    }

    render() {
        const { items, selectedFromList } = this.props;
        const disabled = items.length > 0 ? false : true;
        const headerMessage = "Got it! Here are your next steps.";
        const infoMessage = "Bring your gear in, and we’ll give it an expert evaluation. If we come to an offer you accept, you’ll get paid same-day, or you can trade it in for a discount on something new. ";
        return ( 
            <div className="main-container">
                <a href="#" onClick={this.props.handleClose} className="exit-btn"></a>
                <div className="inventory-list-container"> 
                
                    {this.itemsList(items)}
                    {this.state.detailsView ? 
                    <SubmitDetails {...this.props} hideDetails={this.hideDetails}/> : null}
                    <h2>{headerMessage}</h2>
                    <p>{infoMessage}</p>
                    <div className="button-container row">
                        <div className="col-sm-6 col-xs-12">
                            <label htmlFor="">Ready to come in?</label>
                            <NextButton name="schedule-btn" id="schedule-appointment" text="Schedule an in-store appointment." disabled={disabled} updateStep={this.props.updateStep} option="OPTION-A" submitItem={false} stepNum={5} />
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <label htmlFor="estimate-btn">Want to chat first?</label>
                            <NextButton name="estimate-btn" id="request-contact" text="Request to be contacted via email or phone." disabled={disabled} updateStep={this.props.updateStep} option="OPTION-B" submitItem={false} stepNum={5}/>
                        </div>
                    </div>
                    <p className="quick-tip">Quick tip: Some gear does not qualify for trade-in. Read more about 
                    <Popup btnText=" non-qualifying items here"
                    headerText="Promotion Exclusions"
                    toolTipId="promo-exclusions" />.</p>
                </div>
                <Modal show={this.state.showAddItemModal} onHide={this.handleCloseModal} id="add-item-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Add Another Item</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AddItem {...this.props} handleCloseModal={this.handleCloseModal}/>
                    </Modal.Body>
                </Modal>
            </div>

        );
    }
}

export default InventoryList;